import { Users, Video } from "lucide-react";
import { useAuth } from "../../../context/AuthProvider";
// import { useMeeting } from "../../../context/MeetingContext";
import { useEffect, useState } from "react";
import { useMeetingStore } from "../../../store/meeting.store";
import { socket } from "../../../components/mediasoup/socket";

interface ReaderProps {
  data: any;
}

const ReaderDashboardJoinSession = ({ data }: ReaderProps) => {
  const { user } = useAuth();
  //   const { userData, setUserData, setSelectedCase } = useMeeting();
  const userData = useMeetingStore((s) => s.userData);
  const setUserData = useMeetingStore((s) => s.setUserData);
  const setCourtRoomData = useMeetingStore((s) => s.setCourtRoomData);
  const setMeetingStarted = useMeetingStore((s) => s.setMeetingStarted);

  const [isSystemReady, setIsSystemReady] = useState(false);
  const cnr = data?.data[0]?.cnr;
  useEffect(() => {
    const userdata1 = {
      _id: user?.id || "",
      name: user?.name || "Judge",
      role: "Reader",
      roomNo: data?.courtRoomData?.courtRoomNo || "room-1",
      roomId: data?.courtRoomData?.courtRoomId || "room-1",
    };
    setUserData(userdata1);
    // setSelectedCase(data?.data[0]);
    if (!socket || !cnr || !userData) return;
    // handleJoinRoom();
  }, [socket, data, user]);
  // const handleJoinRoom = () => {
  //   socket?.emit("join-room", {
  //     roomNo: data?.courtRoomData.courtRoomNo,
  //     roomId: data?.courtRoomData.courtRoomId,
  //     userId: user?.id,
  //     role: user?.role,
  //     name: user?.name,
  //     host: true,
  //     cnr,
  //   });
  //   setIsSystemReady(true);
  // };
  const handleJoinSession = () => {
    if (!socket) return;
    // handleJoinRoom();
    // setSelectedCase(findCase);
    setIsSystemReady(true);
    setMeetingStarted(true);
    setCourtRoomData(data?.courtRoomData);

    // socket.emit(
    //   "reader-join",
    //   { roomNo: data?.courtRoomData?.courtRoomId, userId: user?.id },
    //   (socketData: any) => {
    //     if (socketData?.present) {
    //       const findCase = data?.data?.find(
    //         (c: any) => c?.cnr === socketData?.cnr,
    //       );
    //       setSelectedCase(findCase);
    //       setIsSystemReady(true);
    //       setMeetingStarted(true);
    //       toast.success(socketData?.message);
    //     } else {
    //       toast.error(socketData?.message);
    //     }
    //   },
    // );
    // socket?.emit("advocate-accept", {
    //   roomNo: data?.courtRoomData?.courtRoomId,
    //   cnr: data?.data[0]?.cnr,
    //   userId: user?.id,
    // });

    // socket?.emit("advocate-accept", {
    //   roomNo: data?.courtRoomData?.courtRoomId,
    //   cnr: data?.data[0]?.cnr,
    //   userId: user?.id,
    // });
    // setIsStarted(true);
  };
  return (
    <div className="min-h-screen  flex items-center justify-center p-2">
      <div className="w-full max-w-xl mx-auto bg-gradient-to-br from-blue-900 via-blue-800 to-purple-900 rounded-3xl shadow-xl p-6 sm:p-10">
        <div className="">
          {/* Icon */}
          <div className="flex justify-center mb-8">
            <div className="w-20 h-20 bg-gradient-to-br from-purple-400 to-blue-400 rounded-full flex items-center justify-center shadow-lg">
              <Users className="w-10 h-10 text-white" />
            </div>
          </div>

          {/* Title */}
          <h1 className="text-white text-2xl md:text-3xl font-bold text-center mb-6 leading-tight">
            Judicial Session Portal
          </h1>

          {/* Description */}
          <p className="text-blue-100 text-center mb-8 leading-relaxed px-2">
            Welcome, Your Honor. Click below to initiate the court session and
            connect with all participants via secure video conference.
          </p>

          {/* Information Card */}
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 mb-8 border border-white/20">
            <div className="space-y-4">
              {/* Court Number */}
              <div className="flex justify-between items-center">
                <span className="text-blue-200 font-medium">Court Number:</span>
                <span className="text-white font-bold text-lg">
                  {data?.courtRoomData?.courtRoomNo}
                </span>
              </div>

              {/* Judge Name */}
              <div className="flex justify-between items-start">
                <span className="text-blue-200 font-medium">
                  {data?.courtRoomData?.bench ? "Bench Name" : "Judge Name"}:
                </span>
                <span className="text-white font-bold text-right leading-tight">
                  {data?.courtRoomData?.judge || data?.courtRoomData?.bench}
                </span>
              </div>

              {/* Expected Cases */}
              <div className="flex justify-between items-center">
                <span className="text-blue-200 font-medium">
                  Expected Cases:
                </span>
                <span className="text-white font-bold text-lg">
                  {data?.data?.length || 0}
                </span>
              </div>
            </div>
          </div>

          {/* Start Session Button */}
          <button
            disabled={data?.data?.length === 0}
            onClick={handleJoinSession}
            className="w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-bold py-4 px-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98] mb-4"
          >
            <div className="flex items-center justify-center space-x-3">
              <Video className="w-6 h-6" />
              <span className="text-lg">Join Session</span>
            </div>
          </button>

          {/* System Status */}
          <div className="flex items-center justify-center space-x-2">
            <div
              className={`w-3 h-3 rounded-full ${
                isSystemReady ? "bg-green-400" : "bg-red-400"
              } animate-pulse`}
            ></div>
            <span className="text-green-300 text-sm font-medium">
              System Ready
            </span>
          </div>
        </div>

        {/* Additional Mobile Optimizations */}
        <div className="mt-8 text-center">
          <p className="text-blue-300 text-sm opacity-75">
            Secure • Encrypted • Court Authorized
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReaderDashboardJoinSession;
